import axios from "axios";
import http from "./http-common";
import { validateMagicLink } from "Helpers/call_apis";

const getClientIP = async () => {
	try {
		const response = await fetch("https://api.ipify.org?format=json");
		if (response.status === 401) {
			localStorage.removeItem('esignature');
			window.location.href = '/';
			return "unknown";
		}
		const data = await response.json();
		console.log('data',data);
		return data.ip;
	} catch (error) {
		console.error("Error getting client IP:", error);
		return "unknown";
	}
};

export const getDocFormsToAssign = async () => {
	const response = await http.get(
		`${process.env.REACT_APP_HOST_API_FORMS}/forms/api/v1/documents?status=pending`,
		{
			headers: {
				"Content-Type": "application/json",
				Authorization:
					"Bearer " + JSON.parse(localStorage.getItem("esignature") || '{"token":""}').token,
				customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
				userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
			},
		}
	);
	return response.data;
};

export const getDocFormsComlpleted = async () => {
	const response = await http.get(
		`${process.env.REACT_APP_HOST_API_FORMS}/forms/api/v1/documents?status=completed`,
		{
			headers: {
				"Content-Type": "application/json",
				Authorization:	
					"Bearer " + JSON.parse(localStorage.getItem("esignature") || '{"token":""}').token,
				customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
				userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
			},
		}
	);
	return response.data;
};

const getEsignatureSession = () => {
	try {
		return JSON.parse(localStorage.getItem("esignature") || "{}");
	} catch {
		return {};
	}
};

export const isMagicLinkSession = () => getEsignatureSession().isMagicLink === true;

export const isMagicLinkFormCompleted = () => {
	const session = getEsignatureSession();
	return (
		session.magicLinkFormCompleted === true || session.magicLinkFormCompleted === "true"
	);
};

const normalizeValidatePayload = (response) => response?.data?.data ?? response?.data ?? {};

export const syncMagicLinkSessionFromValidate = async () => {
	const session = getEsignatureSession();
	if (!session.isMagicLink || !session.token) {
		return null;
	}
	try {
		const response = await validateMagicLink(session.token);
		const payload = normalizeValidatePayload(response);
		if (payload?.is_valid !== true) {
			localStorage.removeItem("esignature");
			return { expired: true };
		}
		const completed =
			payload?.has_been_used === true || payload?.form_completed === true;
		const updated = {
			...session,
			magicLinkFormCompleted: completed,
			magicLinkTemplateId: payload.template_id || session.magicLinkTemplateId,
			magicLinkFormRequestId:
				payload.form_request_id || session.magicLinkFormRequestId,
			magicLinkExpiresAt: payload.expires_at || session.magicLinkExpiresAt,
			magicLinkExpiresInMinutes:
				payload.expires_in ?? session.magicLinkExpiresInMinutes,
		};
		localStorage.setItem("esignature", JSON.stringify(updated));
		return { completed, canFill: payload?.can_fill === true, payload };
	} catch (error) {
		console.error("Magic link status sync failed:", error);
		return null;
	}
};

export const isMagicLinkSessionExpired = () => {
	const session = getEsignatureSession();
	const expiresAt = session.magicLinkExpiresAt;
	if (!expiresAt) return false;
	const expiry = new Date(expiresAt);
	return Number.isNaN(expiry.getTime()) || expiry.getTime() <= Date.now();
};

export const clearMagicLinkSessionIfExpired = () => {
	if (isMagicLinkSession() && isMagicLinkSessionExpired()) {
		localStorage.removeItem("esignature");
		return true;
	}
	return false;
};

export const getMagicLinkViewPath = () => {
	const session = getEsignatureSession();
	if (!session.magicLinkTemplateId || !session.magicLinkFormRequestId) {
		return null;
	}
	return `/docFormFiller/${session.magicLinkTemplateId}/${session.magicLinkFormRequestId}`;
};

export const getMagicLinkHighlightFormRequestId = () =>
	getEsignatureSession().magicLinkFormRequestId || null;

export const getMagicLinkHighlightedFormName = (forms = []) => {
	const highlightId = getMagicLinkHighlightFormRequestId();
	if (!highlightId) return null;
	const match = forms.find((f) => String(f.id) === String(highlightId));
	return match?.templateName || null;
};

export const formatMagicLinkExpiry = () => {
	const session = getEsignatureSession();
	if (!session.magicLinkExpiresAt) return null;
	const expiry = new Date(session.magicLinkExpiresAt);
	if (Number.isNaN(expiry.getTime())) return null;
	return expiry.toLocaleString(undefined, {
		dateStyle: "medium",
		timeStyle: "short",
	});
};

export const markMagicLinkFormCompleted = () => {
	const session = getEsignatureSession();
	if (!session.isMagicLink) return;
	localStorage.setItem(
		"esignature",
		JSON.stringify({ ...session, magicLinkFormCompleted: true })
	);
};

export const saveMagicLinkSession = ({
	token,
	payload,
	signerEmail,
	displayName,
}) => {
	const userData = {
		email: signerEmail,
		fullName: displayName,
		name: displayName,
		displayName,
		token,
		userId: payload?.user_id,
		userName: payload?.user_name,
		customerId: "",
		isMagicLink: true,
		magicLinkFormCompleted:
			payload?.has_been_used === true || payload?.form_completed === true,
		magicLinkTemplateId: payload?.template_id,
		magicLinkFormRequestId: payload?.form_request_id,
		magicLinkExpiresAt: payload?.expires_at,
		magicLinkExpiresInMinutes: payload?.expires_in,
	};
	localStorage.setItem("esignature", JSON.stringify(userData));
	return userData;
};

const getEsignatureEmail = () => {
	const session = getEsignatureSession();
	return session.email || session.userName || "";
};

export const getDocFormFiller = async (id, form_request_id) => {
	const email = encodeURIComponent(getEsignatureEmail());
	if (!email || email === "null" || email === "undefined") {
		throw new Error("Signer email missing — open the form from your magic link again.");
	}
	const response = await http.get(`${process.env.REACT_APP_HOST_API_FORMS}/forms/api/v1/templates/${id}/json?assignee=${email}&form_request_id=${form_request_id}`, {
			headers: {
				"Content-Type": "application/json",
				Authorization:
					"Bearer " + JSON.parse(localStorage.getItem("esignature") || '{"token":""}').token,
				customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
				userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
			},
	});
	return response.data;
};

export const fillDocForm = async (id, values) => {
	const response = await http.post(`${process.env.REACT_APP_HOST_API_FORMS}/forms/api/v1/fill`, {
		formRequestId: id,
		fields: values,
		ip: await getClientIP(),
	}, {
		headers: {
			"Content-Type": "application/json",
			Authorization:
				"Bearer " + JSON.parse(localStorage.getItem("esignature") || '{"token":""}').token,
		},
	});
	return response.data;
};

export const getSignatureListByUser = async () => {
	const response = await http.get(`${process.env.REACT_APP_HOST_API_FORMS}/forms/api/v1/users/signature`, {
		headers: {
			"Content-Type": "application/json",
			Authorization:
				"Bearer " + JSON.parse(localStorage.getItem("esignature") || '{"token":""}').token,
			customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
			userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
		},
	});
	return response.data;
};

export const updateSignature = async (signature) => {
	const data = {
		"imageFormat": "png",
		signatureBase64: signature,
	}
	const response = await http.put(`${process.env.REACT_APP_HOST_API_FORMS}/forms/api/v1/users/signature`, data, {
		headers: {
			"Content-Type": "application/json",
			Authorization:
			"Bearer " + JSON.parse(localStorage.getItem("esignature") || '{"token":""}').token,
			customerId: JSON.parse(localStorage.getItem("esignature") || '{"customerId":""}').customerId,
			userId: JSON.parse(localStorage.getItem("esignature") || '{"userId":""}').userId,
		},
	});
	return response.data;
};